import LeaveMessagePopup from '../modals/LeaveMessage';

// ATAI-448: legacy-plan accounts can't subscribe to Investor Outreach until they move to
// Essentials, Pro or Elite -- same "Upgrade Your Account" prompt Connect (LeadAutomator) and the
// trial-activation modal already show them. `onNavigate` is how the caller goes to the plan page
// (history.push), so this stays free of router wiring.
export const openLegacyUpgradePopup = ({ onNavigate }) =>
  LeaveMessagePopup.open({
    title: 'Upgrade Your Account',
    message:
      'Upgrade your account to Essentials, Pro, or Elite by clicking Upgrade Plan to continue.',
    autoWidth: false,
    yesLable: 'Upgrade Plan',
    cancelLable: 'Cancel',
    CancelRedirect: () => null,
    yesRedirect: () => {
      if (onNavigate) onNavigate('/accountnew/plan');
    },
  });

export default openLegacyUpgradePopup;
